const TENDER_OFFER_VERSION_STATUSSES = {
  draft: 'draft',
  submitted: 'submitted',
  old: 'old',
  archived: 'archived',
};
export default TENDER_OFFER_VERSION_STATUSSES;
